import { makeStyles } from "@material-ui/core";

const useRbFlexViewItemStyles = makeStyles({
  root: (props) => ({
    boxSizing: "border-box",
    flex: props.flex,
    position: "relative",
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto",
    minWidth: 1,
    minHeight: 1,
  }),
});

export default useRbFlexViewItemStyles;
